import { useState, useRef, useEffect } from 'react'

const C = { card: '#FDFAF6', border: '#DDD4C6', brown: '#2C1D14', muted: '#9A7B68' }

export default function InfoTooltip({ text }) {
  const [visible, setVisible] = useState(false)
  const hideTimer = useRef(null)

  useEffect(() => () => clearTimeout(hideTimer.current), [])

  function show() {
    clearTimeout(hideTimer.current)
    setVisible(true)
  }

  function hide() {
    clearTimeout(hideTimer.current)
    hideTimer.current = setTimeout(() => setVisible(false), 100)
  }

  function tap() {
    if (visible) {
      clearTimeout(hideTimer.current)
      setVisible(false)
    } else {
      setVisible(true)
      hideTimer.current = setTimeout(() => setVisible(false), 4000)
    }
  }

  return (
    <span style={{ position: 'relative', display: 'inline-flex', verticalAlign: 'middle' }}>
      <span
        role="button"
        tabIndex={0}
        aria-label="More information"
        onMouseEnter={show}
        onMouseLeave={hide}
        onClick={tap}
        onKeyDown={(e) => e.key === 'Enter' && tap()}
        style={{
          width: 14, height: 14,
          border: `1px solid ${C.border}`,
          borderRadius: '50%',
          fontSize: 10, fontWeight: 'bold',
          color: C.muted,
          display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          cursor: 'help',
          marginLeft: 6,
          lineHeight: 1,
          flexShrink: 0,
          userSelect: 'none',
        }}
      >
        ?
      </span>
      {visible && (
        <span style={{
          position: 'absolute',
          bottom: '100%',
          left: '50%',
          transform: 'translateX(-50%)',
          marginBottom: 8,
          background: C.brown,
          color: C.card,
          padding: '8px 12px',
          borderRadius: 6,
          fontSize: 12,
          maxWidth: 240,
          lineHeight: 1.4,
          fontFamily: 'Calibri, sans-serif',
          boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          zIndex: 1000,
          whiteSpace: 'normal',
          pointerEvents: 'none',
          textAlign: 'left',
        }}>
          {text}
          <span style={{
            position: 'absolute',
            top: '100%',
            left: '50%',
            transform: 'translateX(-50%)',
            width: 0,
            height: 0,
            borderLeft: '6px solid transparent',
            borderRight: '6px solid transparent',
            borderTop: `6px solid ${C.brown}`,
          }} />
        </span>
      )}
    </span>
  )
}
